import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../components/Hyperlink';
import { getPageName } from '../utils/pageName';
import { buildUrlWithParameters } from '../utils/url-utils/urlUtils';

export class SignupBanner extends React.Component<{}> {
  sourcePage: string = getPageName();

  render() {
    return (
      <div className="banner-customers">
        <div className="banner-customers__block">
          <div className="banner-customers__interview__small_header">
            <h2 className="banner-customers__title">
              <FormattedMessage id="signup/SignupBanner.tsx/1" />
            </h2>
            <p className="banner-customers__subtitle">
              <FormattedMessage id="signup/SignupBanner.tsx/2" />
            </p>
            <p>
              <Hyperlink
                className="button large brand"
                href={buildUrlWithParameters('/inscription', {
                  source: 'banner_signup',
                  sourcePage: this.sourcePage,
                })}
              >
                <FormattedMessage id="signup/SignupBanner.tsx/3" />
              </Hyperlink>
            </p>
            <p className="banner-customers__message">
              <FormattedMessage id="signup/SignupBanner.tsx/4" />{' '}
              <a
                className="banner-customers__message__link"
                onClick={() => window.Intercom('show')}
              >
                <FormattedMessage id="signup/SignupBanner.tsx/5" />
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}
